export default {
  read: {
    title: "Contacta con tu asesor",
    availability:
      "Puedes solicitar una consultoría con un experto para que ayudemos con cualquier cosa. La cantidad de citas depende del plan que tengas (basic o premium) si necesitas más citas siempre puedes cambiar a premium y tendrás 2 extra al mes.",
    premium:
      "Te recomendamos que aproveches estas citas para mejorar tu experiencia con nosotros pero eso sí… ¡no las desperdicies! Cuando hayas reservado y no puedas acudir, cancela la cita con al menos 24h ya que sino perderás una de tus consultorías de ese mes."
  }
};
